import { Table } from "antd";

const Table200 = () => {
    const dataSource = [
        {
            key: 1,
            stt: 'Nhóm 1',
            industry: 'Bệnh viện (Tham gia chương trình Bệnh viện Công của Visa)',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '0.89%',
            visaOther: '0.99%',
            visaForeign: '3.33%',
            masterBidv: '0.89%',
            masterOther: '2.64%',
            masterForeign: '3.19%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 2,
            stt: 'Nhóm 2',
            industry: 'Bệnh viện (Không tham gia Chương trình BV công)',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '0.89%',
            visaOther: '2.32%',
            visaForeign: '3.27%',
            masterBidv: '0.89%',
            masterOther: '2.70%',
            masterForeign: '3.26%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 3,
            stt: 'Nhóm 3',
            industry: 'Siêu thị',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '1.24%',
            visaOther: '1.27%',
            visaForeign: '3.67%',
            masterBidv: '1.19%',
            masterOther: '1.66%',
            masterForeign: '3.67%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 4,
            stt: 'Nhóm 4',
            industry: 'Nhà hàng Đồ ăn Nhanh',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '1.19%',
            visaOther: '1.25%',
            visaForeign: '3.53%',
            masterBidv: '1.19%',
            masterOther: '1.38%',
            masterForeign: '3.52%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 5,
            stt: 'Nhóm 5',
            industry: 'Cửa hàng Điện tử',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '1.19%',
            visaOther: '1.64%',
            visaForeign: '3.28%',
            masterBidv: '1.19%',
            masterOther: '2.60%',
            masterForeign: '3.22%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 6,
            stt: 'Nhóm 6',
            industry: 'Dịch vụ Bảo hiểm',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '1.19%',
            visaOther: '1.21%',
            visaForeign: '3.00%',
            masterBidv: '1.19%',
            masterOther: '2.76%',
            masterForeign: '3.33%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 7,
            stt: 'Nhóm 7',
            industry: 'Quản lý và Đại lý Cho thuê Bất động sản',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '1.19%',
            visaOther: '1.16%',
            visaForeign: '3.50%',
            masterBidv: '1.19%',
            masterOther: '2.76%',
            masterForeign: '3.03%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 8,
            stt: 'Nhóm 8',
            industry: 'Taxi & Limousine',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '1.30%',
            visaOther: '1.30%',
            visaForeign: '4.40%',
            masterBidv: '1.30%',
            masterOther: '1.30%',
            masterForeign: '4.40%',
            cup: '2.3%',
            jcb: '2.3%',
        },
        {
            key: 9,
            stt: 'Nhóm 9',
            industry: 'Cây xăng',
            domesticBidv: '0.63%',
            domesticOther: '0.76%',
            visaBidv: '1.19%',
            visaOther: '1.19%',
            visaForeign: '3.43%',
            masterBidv: '1.19%',
            masterOther: '1.19%',
            masterForeign: '3.41%',
            cup: '2.3%',
            jcb: '2.3%',
        },
    ];

    const columns = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: 55,
            align: 'center',
        },
        {
            title: 'Các ngành nghề',
            dataIndex: 'industry',
            key: 'industry',
            width: 200,
        },
        {
            title: 'Thẻ nội địa',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'domesticBidv',
                    key: 'domesticBidv',
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ NH
                            <br />
                            khác
                        </>
                    ),
                    dataIndex: 'domesticOther',
                    key: 'domesticOther',
                    align: 'center',
                },
            ],
        },
        {
            title: 'Thẻ Visa',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'visaBidv',
                    key: 'visaBidv',
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ NH
                            <br />
                            khác
                        </>
                    ),
                    dataIndex: 'visaOther',
                    key: 'visaOther',
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            Nước ngoài
                        </>
                    ),
                    dataIndex: 'visaForeign',
                    key: 'visaForeign',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },
        {
            title: 'Thẻ Master',
            children: [
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            BIDV
                        </>
                    ),
                    dataIndex: 'masterBidv',
                    key: 'masterBidv',
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ NH
                            <br />
                            khác
                        </>
                    ),
                    dataIndex: 'masterOther',
                    key: 'masterOther',
                    align: 'center',
                },
                {
                    title: (
                        <>
                            Thẻ
                            <br />
                            Nước ngoài
                        </>
                    ),
                    dataIndex: 'masterForeign',
                    key: 'masterForeign',
                    align: 'center',
                    render: (value) => (
                        <span className="text-danger">{value}</span>
                    ),
                },
            ],
        },
        {
            title: (
                <>
                    Thẻ
                    <br />
                    CUP
                </>
            ),
            dataIndex: 'cup',
            key: 'cup',
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },
        {
            title: (
                <>
                    Thẻ
                    <br />
                    JCB
                </>
            ),
            dataIndex: 'jcb',
            key: 'jcb',
            align: 'center',
            render: (value) => (
                <span className="text-danger">{value}</span>
            ),
        },
    ];
    return (
        <div className="mt-5">
            <h2 className="fw-bold fs-5 mb-3">GIÁ PHÍ ĐỐI VỚI BIG MERCHANT (NẾU ĐẠT MỨC DOANH SỐ 200 TỶ)</h2>
            <div>
                <Table
                    bordered
                    pagination={false}
                    dataSource={dataSource}
                    columns={columns}
                    rowKey="key"
                />
            </div>
        </div>

    );
};
export default Table200;